import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=594e0908&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=ts"
export * from "./MainNavigation.vue?vue&type=script&lang=ts"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=594e0908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e0908",
  null
  
)

export default component.exports